// extracted by mini-css-extract-plugin
export var app = "index-module--app--vcCTB";
export var app__page = "index-module--app__page--2B9gM";